<template>
  <div
    class="my-note-page"
    :class="{
      'electron-my-note-page': isElectron,
    }"
  >
    <div class="page-cont-wrap">
      <template v-if="courses?.length">
        <!-- 左侧课程列表 -->
        <div class="course-list">
          <!-- 筛选区域 -->
          <div class="page-tips">仅展示带有笔记的课程</div>

          <!-- 课程列表 -->
          <div class="course-items commom-scrollbar">
            <div
              v-for="course in courses"
              :key="course.course_id"
              :class="[
                'course-item',
                { active: selectedCourseId === course.course_id },
              ]"
              @click="selectCourse(course)"
            >
              <div class="course-info">
                <div class="course-image">
                  <img
                    :src="
                      handleImageUrl(course.cover_url) + '?imageView2/0/w/300'
                    "
                  />
                </div>
                <div class="course-detail">
                  <div class="note-count">{{ course.notes_num }}个笔记</div>
                  <div class="course-name">{{ course.course_name }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              class="custom-pagination"
              background
              layout="prev, pager, next"
              :total="total"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              @current-change="handlePageChange"
            />
          </div>
        </div>

        <!-- 右侧笔记内容 -->
        <div class="note-content">
          <el-collapse class="commom-scrollbar" v-model="activeCollapseItems">
            <el-collapse-item
              v-for="(unit, index) in notes"
              :key="unit.unit_id + index"
              :name="unit.unit_id"
            >
              <template slot="title">
                <div class="note-item-header">
                  <span class="chapter-name">{{ unit.unit_name }}</span>
                </div>
              </template>
              <div
                v-for="(note, index) in unit.user_lesson_notes_list"
                :key="note.lesson_id + index"
                class="note-item-content"
                @click="jumpNoteDetail(note.lesson_id)"
              >
                <div class="lesson-title-wrap">
                  <div class="lesson-title">
                    <img
                      v-if="note.is_ai === 1"
                      class="ai-icon"
                      src="../../assets/images/icon/ai-icon.png"
                      alt=""
                    />
                    <p class="title ellipsis">
                      {{ note.lesson_name }}
                    </p>
                  </div>
                  <div class="time-wrap">
                    <span class="note-time"
                      >{{
                        moment(note.updated_at * 1000).format(
                          "YYYY.MM.DD HH:mm:ss"
                        )
                      }}
                      更新</span
                    >
                    <span class="divider"></span>
                    <button
                      type="del-btn"
                      @click.stop="handleDeleteNote(note.id)"
                    >
                      <img
                        class="del-icon"
                        src="../../assets/images/icon/del-icon.png"
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div class="note-text multiline-ellipsis">
                  {{ note.summary || extractTextFromHtml(note.content)?.text }}
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </template>
      <!-- 空 -->
      <el-empty
        class="page-empty"
        v-else
        description="暂无笔记"
        :image="require('../../assets/images/icon/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import {
  getCourseWithNotes,
  getCourseNotes,
  deleteNote,
} from "@saas/service-api/src/note";
import moment from "moment";
import {
  handleImageUrl,
  isMobile,
  extractTextFromHtml,
} from "@saas/components/src";

export default {
  name: "MyNote",

  data() {
    return {
      handleImageUrl,
      moment,
      // 课程数据
      courses: [],
      selectedCourseId: null,

      // 笔记数据
      notes: [],

      // 加载状态
      loading: false,

      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,

      activeCollapseItems: [], // 默认全部展开
      isElectron: window.isElectron,
      isMobile: isMobile(),
      extractTextFromHtml,
    };
  },

  computed: {},

  methods: {
    // extractTextFromHtml(html) {
    //   const parser = new DOMParser();
    //   const doc = parser.parseFromString(html, "text/html");

    //   let haveAIBlock = false;

    //   function extractText(node) {
    //     // 处理公式元素
    //     if (
    //       node.nodeType === Node.ELEMENT_NODE &&
    //       node.getAttribute("data-w-e-type") === "formula"
    //     ) {
    //       return "[公式]";
    //     }

    //     // 处理标记块元素
    //     if (
    //       node.nodeType === Node.ELEMENT_NODE &&
    //       node.getAttribute("data-w-e-type") === "markblock"
    //     ) {
    //       return "[标记]";
    //     }

    //     // 处理AI问答块元素
    //     if (
    //       node.nodeType === Node.ELEMENT_NODE &&
    //       node.getAttribute("data-w-e-type") === "qablock"
    //     ) {
    //       haveAIBlock = true;
    //       return "[AI问答]";
    //     }

    //     // 处理图片元素
    //     if (
    //       node.nodeType === Node.ELEMENT_NODE &&
    //       node.tagName.toLowerCase() === "img"
    //     ) {
    //       return "[图片]";
    //     }

    //     // 处理文本节点
    //     if (node.nodeType === Node.TEXT_NODE) {
    //       return node.textContent;
    //     }

    //     // 递归处理子节点
    //     let result = "";
    //     for (let child of node.childNodes) {
    //       result += extractText(child);
    //     }

    //     // 如果是块级元素，添加换行符
    //     // if (node.nodeType === Node.ELEMENT_NODE) {
    //     //   const display = window.getComputedStyle(node).display;
    //     //   if (
    //     //     ["block", "table", "div", "p", "pre", "li", "ol", "ul"].includes(
    //     //       display
    //     //     )
    //     //   ) {
    //     //     result += "\n";
    //     //   }
    //     // }
    //     return result;
    //   }

    //   // 提取文本后去除所有空白字符
    //   return { text: extractText(doc.body).replace(/\s+/g, ""), haveAIBlock };
    // },
    jumpNoteDetail(lessonId) {
      const url = `/note/${lessonId}`;
      if (this.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    // 获取课程列表
    apiGetCourseWithNotes(type) {
      let params = {
        page_no: this.currentPage,
        page_size: this.pageSize,
      };
      getCourseWithNotes(params).then((res) => {
        if (res.code === 1) {
          this.courses = res.data.list || [];
          this.total = res.data.total;
          if (this.courses.length > 0) {
            if (type === "delete") {
              let selectCourse = this.courses.find((course) => {
                return course.course_id === this.selectedCourseId;
              });
              // 如果删除的笔记所在课时已不存在，默认选择第一个课时
              if (!selectCourse?.course_id) {
                this.selectedCourseId = this.courses[0].course_id;
              }
            } else {
              this.selectedCourseId = this.courses[0].course_id;
            }
            this.apiGetCourseNotes(this.selectedCourseId);
          } else if (type === "delete" && this.currentPage > 1) {
            // 如果当前页没有数据，且不是第一页，跳转到上一页
            this.currentPage = this.currentPage - 1;
            this.apiGetCourseWithNotes();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 处理分页变化
    handlePageChange(page) {
      this.currentPage = page;
      this.apiGetCourseWithNotes();
    },

    // 选择课程
    selectCourse(course) {
      this.selectedCourseId = course.course_id;
      this.apiGetCourseNotes(course.course_id);
    },

    // 获取课程笔记
    async apiGetCourseNotes(type) {
      let params = {
        course_id: this.selectedCourseId,
      };
      getCourseNotes(params).then((res) => {
        if (res.code === 1) {
          // 提取笔记内容文字
          this.notes = res.data || [];
          // this.notes = (res.data || []).map((unit) => {
          //   unit.user_lesson_notes_list = (
          //     unit?.user_lesson_notes_list || []
          //   ).map((note) => {
          //     if (note?.summary) {
          //       const { haveAIBlock, text } = extractTextFromHtml(note.content);

          //       return {
          //         ...note,
          //         haveAIBlock,
          //         text,
          //       };
          //     }else{

          //     }
          //   });
          //   return unit;
          // });
          // 设置所有笔记项为展开状态
          this.activeCollapseItems = this.notes.map((unit) => {
            return unit.unit_id;
          });
          if (!this.notes?.length && type === "delete") {
            this.apiGetCourseWithNotes("delete");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 执行删除
    handleDelete(noteId) {
      let params = {
        id: noteId,
      };
      deleteNote(params).then((res) => {
        if (res.code === 1) {
          this.$message.success("删除成功");
          this.apiGetCourseWithNotes("delete");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleDeleteNote(noteId) {
      // 设置要删除的笔记并显示确认对话框
      this.$confirm("是否确认删除笔记", "提示", {
        center: true,
        confirmButtonText: "确定",
        customClass: "saas-confirm-message",
        confirmButtonClass: "confirm-btn",
        cancelButtonClass: "cancel-btn",
        closeOnClickModal: false,
      })
        .then(() => {
          // 执行删除操作
          this.handleDelete(noteId);
        })
        .catch(() => {});
    },
  },

  activated() {
    console.log("keepAlive activated");
  },

  created() {
    console.log("keepAlive created");
    this.apiGetCourseWithNotes();
  },
};
</script>

<style lang="scss" scoped>
.my-note-page {
  height: calc(100vh - #{$nav-bar-height});
  padding: 15px 0;
  .page-cont-wrap {
    display: flex;
    width: $page-cont-width;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 20px;
    overflow: hidden;
    height: 100%;
  }
  .page-empty {
    width: 100%;
  }

  // 左侧课程列表
  .course-list {
    width: 358px;
    padding: 12px 6px;
    background: #fff;
    border-right: 1px solid #efefef;
    display: flex;
    flex-direction: column;

    .page-tips {
      margin-bottom: 12px;
      font-size: 12px;
      color: #515350;
      line-height: 17px;
      margin-left: 8px;
    }

    .course-items {
      flex: 1;
      overflow-y: auto;

      .course-item {
        cursor: pointer;
        margin-bottom: 6px;
        width: 100%;
        height: 90px;
        border-radius: 12px;
        border: 1px solid #fff;
        display: flex;
        align-items: center;

        &:hover {
          background: $saas-bg-color;
        }

        &.active {
          border: 1px solid #00c89d;
        }

        .course-info {
          display: flex;
          align-items: center;
          padding: 0 12px 0 6px;

          .course-image {
            width: 150px;
            height: 84px;
            border-radius: 12px;
            overflow: hidden;
            flex-shrink: 0;
            object-fit: cover;
            margin-right: 12px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .course-detail {
            flex: 1;
            display: flex;
            flex-direction: column;
            padding: 6px 0 4px;
            height: 84px;
            justify-content: space-between;

            .note-count {
              font-weight: 600;
              font-size: 16px;
              color: #0d1400;
              line-height: 22px;
            }

            .course-name {
              font-size: 14px;
              color: #575859;
              line-height: 20px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
    }

    .pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 12px;

      // todo:全局修改
      ::v-deep .el-pagination.custom-pagination {
        .el-pager li {
          min-width: 28px;
          background: #f7f8fa;
          border-radius: 6px;
          padding: 0;
          margin: 0 5px;
          font-weight: 400;
          font-size: 12px;
        }
        .el-pager li.active {
          background: #e5faf5;
          color: $saas-theme-color;
          font-weight: 400;
          font-size: 12px;
        }
        .el-pagination .btn-prev,
        .btn-next {
          padding: 0 5px;
          min-width: 28px;
          margin: 0 5px;
          background: #f7f8fa;
          border-radius: 6px;
        }
      }
    }
  }

  // 右侧笔记内容
  .note-content {
    flex: 1;
    padding: 12px;
    background: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;

    .el-collapse {
      flex: 1;
      overflow-y: auto;
      border-top: none;
      border-bottom: none;

      ::v-deep .el-collapse-item__arrow.el-icon-arrow-right.is-active {
        transform: rotate(-90deg);
      }
      ::v-deep .el-collapse-item__arrow.el-icon-arrow-right {
        transform: rotate(90deg);
      }

      ::v-deep .el-collapse-item__header {
        height: 44px;
        background: $saas-bg-color;
        border-radius: 12px;
        border: none;
        padding: 12px;
        font-size: 16px;
        color: $saas-text-color;
        line-height: 20px;

        i {
          color: $plain-text-color;
          font-size: 12px;
          font-weight: 600;
        }
      }
      ::v-deep .el-collapse-item {
        margin-bottom: 24px;
      }

      ::v-deep .el-collapse-item__content {
        padding: 0;
      }
      ::v-deep .el-collapse-item__wrap {
        border-bottom: none;
      }

      .note-item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .chapter-name {
          font-weight: 500;
        }

        .note-time {
          color: #999;
          font-size: 12px;
        }
      }

      .note-item-content {
        padding: 12px 3px;
        border-bottom: 1px solid #efefef;
        &:hover {
          background: $saas-bg-color;
          cursor: pointer;
        }
        .lesson-title-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .lesson-title {
          flex: 1;
          display: flex;
          align-items: center;
          .ai-icon {
            width: 22px;
            height: 22px;
          }
          .title {
            font-size: 14px;
            color: #0d1400;
            line-height: 20px;
            width: 90%;
          }
        }
        .time-wrap {
          display: flex;
          align-items: center;
          .note-time {
            font-size: 12px;
            color: #515350;
            line-height: 1;
          }
          .del-icon {
            width: 14px;
            height: 14px;
          }
          .divider {
            width: 1px;
            height: 12px;
            background: #e5e6eb;
            margin: 0 6px 0 8px;
          }
        }
        .note-text {
          margin-top: 6px;
          font-size: 12px;
          color: #515350;
          line-height: 17px;
          padding: 0 0 0 3px;
          word-break: break-all;
        }
      }
    }
  }
}

// Electron 样式
.my-note-page.electron-my-note-page {
  height: calc(100vh - #{$top-bar-height});
  padding: 5px 0 14px 0;
  .page-cont-wrap {
    width: 1226px;
  }
}
</style>
